import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DetailsBody from '@/components/VarausDetails/DetailsBody';
import { useVarausDetails } from '@/hooks/useVarausDetails';
import { updateAsArrived, updateAsNotArrived, updateAsLeft, updateAsNotLeft } from '@/services/vastaanottoService';
import { toast } from 'react-toastify';
import { useToastError } from '@/hooks/useToastError';
import { useTranslation } from 'react-i18next';

const DetailsAccordion = ({ data, showSiivous }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const varausId = data?.id?.varausId;
  const { details, loading, error, setDetails } = useVarausDetails(open ? varausId : null);
  useToastError(error, t('detailsAccordion.fetchError'));

  const onToggleSaapumisStatus = async (field, value) => {
    if (!varausId) return;

    const prev = details;

    setDetails(d => ({ ...d, [field]: value }));

    try {
      if (field === 'saapunut') {
        if (value) await updateAsArrived(data.id.varausId);
        else await updateAsNotArrived(data.id.varausId);
      }
      if (field === 'lahtenyt') {
        if (value) await updateAsLeft(data.id.varausId);
        else await updateAsNotLeft(data.id.varausId);
      }
    }
    catch (e) {
      toast.error(t('detailsAccordion.arrivalError'));
      setDetails(prev);
    }
  };

  if (error) return null;

  return (
    <Accordion disableGutters elevation={1} sx={{ borderRadius: 2 }} expanded={open} onChange={() => setOpen(o => !o)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="subtitle1">
            {data.kohteenNimi || 'N/A'}
          </Typography>
          <Typography variant="subtitle2">
            {data.omavaraus ? t('detailsAccordion.ownReservation') : `${data.nimi}`}
          </Typography>
        </Box>
      </AccordionSummary>

      <AccordionDetails>
        { loading
          ? (
              <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                <CircularProgress />
              </Box>
            )
          : (
              <DetailsBody data={data} details={details} onToggleStatus={onToggleSaapumisStatus} showSiivous={showSiivous} />
            )}
      </AccordionDetails>
    </Accordion>
  );
};

export default DetailsAccordion;
